"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RESUBSCRIBE_THROTTLE = 100;
class BaseDataService {
    constructor(apiService) {
        this.lastResubscribed = null;
        this.resubscribeTimeout = null;
        this.lists = [];
        this.listPromises = {};
        this.apiService = apiService;
    }
    getVisibleObjects() {
        return [];
    }
    sendResubRequest() {
        if (this.resubscribeTimeout) {
            clearTimeout(this.resubscribeTimeout);
            this.resubscribeTimeout = null;
        }
        this.lastResubscribed = new Date().getTime();
        this.apiService.setVisibleObjects(this.getVisibleObjects());
    }
    mergeIntoList(array, object) {
        let oldObject = object.id ? array.find(o => o.id === object.id) : null;
        if (oldObject) {
            Object.keys(object).forEach(function (newKey) {
                if (newKey.substr(0, 1) === '_' && newKey !== '_events' && newKey !== '_eventsCount') {
                    oldObject[newKey] = object[newKey];
                }
            });
            return oldObject;
        }
        else {
            array.push(object);
            return object;
        }
    }
    resubscribe() {
        let thisDate = new Date().getTime();
        if (this.resubscribeTimeout === null) {
            if (this.lastResubscribed === null || thisDate - this.lastResubscribed > RESUBSCRIBE_THROTTLE) {
                this.sendResubRequest();
            }
            else {
                let toWait = RESUBSCRIBE_THROTTLE - (thisDate - this.lastResubscribed);
                let self = this;
                this.resubscribeTimeout = setTimeout(function () {
                    self.sendResubRequest();
                }, toWait);
            }
        }
    }
}
exports.default = BaseDataService;
//# sourceMappingURL=base-data-service.js.map